import { Layer, Source } from 'react-map-gl';

// Componente que renderiza layers fijas invisibles, para tener de referencia
// al ordenar las demás layers con 'beforeId'
function MapOrderingLayer() {
  const layersOrder = ['raster', 'polygon', 'line', 'current-line'];

  return (
    <div>
      {
        layersOrder.map(layer => (
          <Source
            key={layer}
            id={'order-'+layer+'-source'}
            type='geojson'
            data={{
              type: 'Feature',
              geometry: {
                type: 'LineString',
                coordinates: [[0,0], [1,1]],
              },
              properties: {},
            }}
          >
            <Layer id={'order-' + layer} type={'line'} paint={{'line-color': 'transparent'}}  />
          </Source>
        ))
      }
    </div>
  );
}

export default MapOrderingLayer;
